<app-stepper-container [isAllowedToNavigate]=true>

    <app-stepper title="1. Permit Information"  [isProgress]='isDepotsInProgress'>
          <app-app-permit-type [dataCntrl]="dataCntrl"  [isInStepper]="true" (nextStepEmitter)="goNext()" ></app-app-permit-type>
    </app-stepper>

    <app-stepper title="2. Vehicle" [isProgress]='isVehicleInProgress'>
        <app-app-vehicle [dataCntrl]="dataCntrl" [isInStepper]="true" (nextStepEmitter)="goNext()"  (prevStepEmitter)="prevStep()"></app-app-vehicle>
    </app-stepper>

    <app-stepper title="3. Routes" [isProgress]='isDriverInProgress'>
        <app-manage-vehicles [isInStepper]="true" [stepperCarrierId]="carrierId" (prevStepEmitter)="prevStep()" (nextStepEmitter)="goNext()" style="width: 1200px;"></app-manage-vehicles>
    </app-stepper>

    <app-stepper title="4. Motivation" [isProgress]='isVehicleInProgress'>
        <app-questionnaire [isInStepper]="true" (prevStepEmitter)="prevStep()" (nextStepEmitter)="goNext()"></app-questionnaire>
    </app-stepper>
    <app-stepper title="5. Timetable" [isProgress]='isVehicleInProgress'>
        <app-questionnaire [isInStepper]="true" (prevStepEmitter)="prevStep()" (nextStepEmitter)="goNext()"></app-questionnaire>
    </app-stepper>
    <app-stepper title="5. Documents" [isProgress]='isVehicleInProgress'>
        <app-questionnaire [isInStepper]="true" (prevStepEmitter)="prevStep()" (nextStepEmitter)="goNext()"></app-questionnaire>
    </app-stepper>
    <app-stepper title="6. Documents" [isProgress]='isVehicleInProgress'>
        <app-questionnaire [isInStepper]="true" (prevStepEmitter)="prevStep()" (nextStepEmitter)="goNext()"></app-questionnaire>
    </app-stepper>
    <app-stepper title="6. Review" [isProgress]='isVehicleInProgress'>
        <app-questionnaire [isInStepper]="true" (prevStepEmitter)="prevStep()" (nextStepEmitter)="goNext()"></app-questionnaire>
    </app-stepper>
    <app-stepper title="7. Review" [isProgress]='isVehicleInProgress'>
        <app-questionnaire [isInStepper]="true" (prevStepEmitter)="prevStep()" (nextStepEmitter)="goNext()"></app-questionnaire>
    </app-stepper>

</app-stepper-container>
